import { toast } from "react-toastify"
import axiosInstance from "../../../services/axios-client"
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Space, Tag } from 'antd';
import { BsFillPencilFill } from "react-icons/bs"
import { IoEyeSharp } from "react-icons/io5"
import ButtonRating from "../../../components/button/ButtonRating";

const useSummaryCurrentProject = () => {
    const [userSummary, setUser] = useState()
    const [summary, setSummary] = useState()
    const [project, setProject] = useState()
    const [loadingPagestate, setLoadingPage] = useState(false)
    const [optionFilterRow, setOptionFilterRow] = useState()
    const [filteredRow, setFilteredRow] = useState()
    const [calibratorFilter, setCalibratorFilter] = useState()

    const navigate = useNavigate()
    const columns = [
        // {
        //     title: 'Pillar',
        //     dataIndex: 'pillar',
        //     key: 'pillar',
        //     fixed: 'left',
        //     render: (text, record) => {
        //         if (record.key === "last") {
        //             return { 
        //                 children: text,
        //                 props: {
        //                     rowSpan: 0,
        //                   },
        //             };
        //         } else if (record.key === "last-1") {
        //             return { 
        //                 children: text,
        //                 props: {
        //                     rowSpan: 2,
        //                   },
        //             };
        //         } else{
        //             return {
        //               children: text,
        //               props: {
        //                 rowSpan: record.rowSpan,
        //               },
        //             };
        //         }
        //     },
        // },
        {
            title: 'Business Unit',
            dataIndex: 'businessPerformance',
            key: 'businessPerformance',
            fixed: 'left',
            render: (text, record) => {
                if (record.position === "last") {
                    return {
                        children: text,
                        props: {
                            rowSpan: 0,
                        },
                    };
                } else if (record.position === "last-1") {
                    return {
                        children: text,
                        props: {
                            rowSpan: 2,
                        },
                    };
                } else {
                    return {
                        children: text,
                        props: {
                            rowSpan: record.rowSpan,
                        },
                    };
                }
            },
        },
        {
            title: 'Previous Calibrator',
            dataIndex: 'previousCalibrator',
            key: 'previousCalibrator',
            // fixed: 'left',
            width: '15%',
            render: (text, record) => {
                if (record.position === "last" || record.position === "totalbu") {
                    return {
                        children: text,
                        props: {
                            rowSpan: 1,
                        },
                    };
                } else if (record.position === "last-1" || record.position === "totalbu-1") {
                    return {
                        children: text,
                        props: {
                            rowSpan: 1,
                        },
                    };
                } else {
                    return {
                        children: text,
                    };
                }
            },
        },
        {
            title: 'Indicator',
            dataIndex: 'indicator',
            key: 'indicator',
            // fixed: 'left',
            width: '14%',
            render: (_, { indicator }) => (
                <div
                    className="d-flex flex-column align-items-start justify-content-center"
                    style={{
                        height: "30px"
                    }}
                >
                    {indicator}
                </div>
            ),
        },
        {
            title: 'A+',
            dataIndex: 'aPlusTotalScore',
            key: 'aPlusTotalScore',
            width: '5%',
            render: (_, { aPlusTotalScore }) => (
                <div className="text-center">
                    <b>{aPlusTotalScore}</b>
                </div>
            ),
        },
        {
            title: 'A',
            dataIndex: 'aTotalScore',
            key: 'aTotalScore',
            width: '5%',
            render: (_, { aTotalScore }) => (
                <div className="text-center">
                    <b>{aTotalScore}</b>
                </div>
            ),
        },
        {
            title: 'B+',
            dataIndex: 'bPlusTotalScore',
            key: 'bPlusTotalScore',
            width: '5%',
            render: (_, { bPlusTotalScore }) => (
                <div className="text-center">
                    <b>{bPlusTotalScore}</b>
                </div>
            ),
        },
        {
            title: 'B',
            dataIndex: 'bTotalScore',
            key: 'bTotalScore',
            width: '5%',
            render: (_, { bTotalScore }) => (
                <div className="text-center">
                    <b>{bTotalScore}</b>
                </div>
            ),
        },
        {
            title: 'C',
            dataIndex: 'cTotalScore',
            key: 'cTotalScore',
            width: '5%',
            render: (_, { cTotalScore }) => (
                <div className="text-center">
                    <b>{cTotalScore}</b>
                </div>
            ),
        },
        {
            title: 'D',
            dataIndex: 'dTotalScore',
            key: 'dTotalScore',
            width: '5%',
            render: (_, { dTotalScore }) => (
                <div className="text-center">
                    <b>{dTotalScore}</b>
                </div>
            ),
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            width: '5%',
            render: (_, { total }) => (
                <div className="text-center">
                    {total}
                </div>
            ),
        },
        {
            title: 'Average',
            dataIndex: 'average',
            key: 'average',
            width: '7%',
            render: (_, { average }) => (
                <div className="text-center">
                    {average}
                </div>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: '7%',
            render: (_, { status }) => (
                <>
                    {
                        status && status !== "summary" ?
                            <Tag
                                style={{ margin: 0 }}
                                data-tooltip-id="tooltip-status"
                                color={status === 'Complete' ? 'green' : status === 'Calibrate' ? 'blue' : 'yellow'}
                                key={status}
                            >
                                {status}
                            </Tag> :
                            <></>
                    }
                </>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            width: '5%',
            render: (_, record) => {
                const projectPhaseOrderParam = record.projectPhaseOrder ? `?projectPhaseOrder=${encodeURIComponent(record.projectPhaseOrder)}` : ""
                return (<Space size="middle">
                    {
                        record.type !== "all" && (record.status === "Complete" || record.status === "Waiting") ?
                            <button
                                className="transparent-button"
                                onClick={() => {
                                    const target = `/projects/${record.projectID}/${record.businessPerformanceID}/${record.previousCalibratorID}/${record.previousCalibrator}/${record.type}/1${projectPhaseOrderParam}`
                                    console.debug("[Summary Navigate]", target)
                                    navigate(target)
                                }}
                                title="View Details"
                                style={{
                                    padding: '3px 5px',
                                    borderRadius: '5px',
                                    border: '1px solid #02B4CC',
                                    backgroundColor: 'transparent',
                                    color: '#02B4CC',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: '24px',
                                    height: 'min-content'
                                }}
                            >
                                <IoEyeSharp style={{ fontSize: '12px' }} />
                            </button> :
                            <></>
                    }
                    {
                        record.type !== "all" && record.status === "Calibrate" ?
                            <button
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => {
                                    const target = `/projects/${record.projectID}/${record.businessPerformanceID}/${record.previousCalibratorID}/${record.previousCalibrator}/${record.type}${projectPhaseOrderParam}`
                                    console.debug("[Summary Navigate]", target)
                                    navigate(target)
                                }}
                                title="Edit Calibration"
                                style={{
                                    height: 'min-content',
                                    borderRadius: '5px',
                                    padding: '3px 5px !important',
                                    minWidth: '24px',
                                    fontSize: '12px'
                                }}
                            >
                                <BsFillPencilFill style={{ fontSize: '12px' }} />
                            </button> :
                            <></>
                    }
                    {
                        record.type === "all" && (record.status === "Complete" || record.status === "Waiting") ?
                            <button
                                className="transparent-button"
                                onClick={() => {
                                    const target = `/projects/${record.projectID}/${record.businessPerformanceID}/${record.type}/1${projectPhaseOrderParam}`
                                    console.debug("[Summary Navigate]", target)
                                    navigate(target)
                                }}
                                title="View All"
                                style={{
                                    padding: '3px 5px',
                                    borderRadius: '5px',
                                    border: '1px solid #02B4CC',
                                    backgroundColor: 'transparent',
                                    color: '#02B4CC',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: '24px',
                                    height: 'min-content'
                                }}
                            >
                                <IoEyeSharp style={{ fontSize: '12px' }} />
                            </button> :
                            <></>
                    }
                    {
                        record.type === "all" && record.status === "Calibrate" ?
                            <button
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => {
                                    const target = `/projects/${record.projectID}/${record.businessPerformanceID}/${record.type}${projectPhaseOrderParam}`
                                    console.debug("[Summary Navigate]", target)
                                    navigate(target)
                                }}
                                title="Edit All"
                                style={{
                                    height: 'min-content',
                                    borderRadius: '5px',
                                    padding: '3px 5px !important',
                                    minWidth: '24px',
                                    fontSize: '12px',
                                    background: 'linear-gradient(to bottom right, #02B4CC 0%, #0284C7 100%)',
                                    border: 'none',
                                }}
                            >
                                <BsFillPencilFill style={{ fontSize: '12px', color: '#ffffff' }} />
                            </button> :
                            <></>
                    }
                    {
                        record.type === "all" && record.status === "summary" ?
                            <button
                                className="transparent-button"
                                onClick={() => navigate(`/projects-summary-all/${record.projectID}`)}
                                title="View Summary"
                                style={{
                                    padding: '3px 5px',
                                    borderRadius: '5px',
                                    border: '1px solid #02B4CC',
                                    backgroundColor: 'transparent',
                                    color: '#02B4CC',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: '24px',
                                    height: 'min-content'
                                }}
                            >
                                <IoEyeSharp style={{ fontSize: '12px' }} />
                            </button> :
                            <></>
                    }
                </Space>
                )
            },
        },
    ];

    const getSummary = async (id, projectID, filteredPrevCalibrator) => {
        try {
            setLoadingPage(true)
            var dataPrevCalibrator = ""
            if (filteredPrevCalibrator) {
                var cleanedCalibrator = filteredPrevCalibrator.filter(item =>
                    !item.startsWith("Total Calibrated") &&
                    !item.startsWith("Rating Guidance")
                );
                dataPrevCalibrator = cleanedCalibrator.join(",")
            }

            // console.log("ISI DATANYA", dataPrevCalibrator)
            let res = await axiosInstance.get(`/auth/projects/summary-calibration?projectID=${projectID}&calibratorID=${id}&prevCalibratorIDs=${dataPrevCalibrator}`)
            let listFilterRow = []
            let listCalibratorFilter = []
            // Only build filter options from unfiltered data
            const shouldBuildOptions = !filteredPrevCalibrator || (Array.isArray(filteredPrevCalibrator) && filteredPrevCalibrator.length === 0)
            if (res.status === 200) {
                let resultData = res.data.data
                // console.log("datanya ", resultData)
                let data = []
                // let businessUnit = {}
                let key = 1
                // console.log("RES DATA", resultData.Summary, " filternya ", filteredPrevCalibrator)
                resultData.Summary.forEach(bu => {
                    if (shouldBuildOptions) {
                        listFilterRow.push({ 'label': bu.CalibratorBusinessUnitName, 'value': bu.CalibratorBusinessUnitID, 'type': 'BU' })
                    }

                    // Collect all rows for this BU first
                    let buRows = []

                    bu.CalibratorBusinessUnit.forEach(element => {
                        let types = "default"
                        if (element.CalibratorName === "N-1") {
                            types = "n-1"
                        }
                        if (filteredPrevCalibrator === undefined || (Array.isArray(filteredPrevCalibrator) && (filteredPrevCalibrator.length === 0 || (filteredPrevCalibrator.length > 0 && filteredPrevCalibrator.includes(`${element.CalibratorID}-${element.CalibratorBusinessUnitID}`))))) {
                            let calName = element.CalibratorName
                            if (element.CalibratorName === "N-1") {
                                calName = "Direct Subordinate"
                            }
                            buRows.push({
                                key: key,
                                // pillar: element.Pillar,
                                businessPerformance: element.CalibratorBusinessUnit,
                                businessPerformanceID: element.CalibratorBusinessUnitID,
                                previousCalibrator: calName,
                                previousCalibratorID: element.CalibratorID,
                                projectPhaseOrder: element.ProjectPhaseOrder,
                                indicator: "Calibrated",
                                aPlusTotalScore: <ButtonRating value={element.APlus} project_id={projectID} bu={element.CalibratorBusinessUnitID} prev_calibrator={element.CalibratorID} rating={"A+"} projectPhaseOrder={element.ProjectPhaseOrder} />,
                                aTotalScore: <ButtonRating value={element.A} project_id={projectID} bu={element.CalibratorBusinessUnitID} prev_calibrator={element.CalibratorID} rating={"A"} projectPhaseOrder={element.ProjectPhaseOrder} />,
                                bPlusTotalScore: <ButtonRating value={element.BPlus} project_id={projectID} bu={element.CalibratorBusinessUnitID} prev_calibrator={element.CalibratorID} rating={"B+"} projectPhaseOrder={element.ProjectPhaseOrder} />,
                                bTotalScore: <ButtonRating value={element.B} project_id={projectID} bu={element.CalibratorBusinessUnitID} prev_calibrator={element.CalibratorID} rating={"B"} projectPhaseOrder={element.ProjectPhaseOrder} />,
                                cTotalScore: <ButtonRating value={element.C} project_id={projectID} bu={element.CalibratorBusinessUnitID} prev_calibrator={element.CalibratorID} rating={"C"} projectPhaseOrder={element.ProjectPhaseOrder} />,
                                dTotalScore: <ButtonRating value={element.D} project_id={projectID} bu={element.CalibratorBusinessUnitID} prev_calibrator={element.CalibratorID} rating={"D"} projectPhaseOrder={element.ProjectPhaseOrder} />,
                                total: <i>{element.APlus + element.A + element.BPlus + element.B + element.C + element.D}</i>,
                                status: element.Status,
                                average: element.AverageScore.toFixed(2),
                                projectID: projectID,
                                type: types,
                            })
                        }
                        key++
                        if (shouldBuildOptions) {
                            listCalibratorFilter.push({ 'label': `${element.CalibratorBusinessUnit} - ${element.CalibratorName}`, 'value': `${element.CalibratorID}-${element.CalibratorBusinessUnitID}`, 'type': 'User', 'bu_id': element.CalibratorBusinessUnitID })
                        }
                    })
                    if (shouldBuildOptions) {
                        listCalibratorFilter.push({ 'label': `Rating Guidance - ${bu.CalibratorBusinessUnitName}`, 'value': `Rating Guidance - ${bu.CalibratorBusinessUnitName}`, 'type': 'User', 'bu_id': bu.CalibratorBusinessUnitID })
                        listCalibratorFilter.push({ 'label': `Total Calibrated - ${bu.CalibratorBusinessUnitName}`, 'value': `Total Calibrated - ${bu.CalibratorBusinessUnitName}`, 'type': 'User', 'bu_id': bu.CalibratorBusinessUnitID })
                    }

                    let filterRating = true
                    let filterTotal = true
                    if (filteredPrevCalibrator === undefined) {
                        filterRating = true
                    } else {
                        if (Array.isArray(filteredPrevCalibrator) && (filteredPrevCalibrator.length === 0 || (filteredPrevCalibrator.length > 0 && filteredPrevCalibrator.includes(`Rating Guidance - ${bu.CalibratorBusinessUnitName}`)))) {
                            filterRating = true
                        } else {
                            filterRating = false
                        }

                        if (Array.isArray(filteredPrevCalibrator) && (filteredPrevCalibrator.length === 0 || (filteredPrevCalibrator.length > 0 && filteredPrevCalibrator.includes(`Total Calibrated - ${bu.CalibratorBusinessUnitName}`)))) {
                            filterTotal = true
                        } else {
                            filterTotal = false
                        }

                    }

                    // Add Total row first if it should be shown
                    if (filterTotal) {
                        const defaultProjectPhaseOrder = bu.CalibratorBusinessUnit?.[0]?.ProjectPhaseOrder
                        data.push({
                            key: key,
                            position: "totalbu",
                            businessPerformance: bu.CalibratorBusinessUnitName,
                            businessPerformanceID: bu.CalibratorBusinessUnitID,
                            previousCalibrator: <b>Total</b>,
                            previousCalibratorID: bu.CalibratorID,
                            projectPhaseOrder: defaultProjectPhaseOrder,
                            indicator: <b>Calibrated</b>,
                            aPlusTotalScore: <ButtonRating value={<b>{bu.APlusCalibrated}</b>} project_id={projectID} bu={bu.CalibratorBusinessUnitID} prev_calibrator={bu.CalibratorID} rating={"A+"} all={true} />,
                            aTotalScore: <ButtonRating value={<b>{bu.ACalibrated}</b>} project_id={projectID} bu={bu.CalibratorBusinessUnitID} prev_calibrator={bu.CalibratorID} rating={"A"} all={true} />,
                            bPlusTotalScore: <ButtonRating value={<b>{bu.BPlusCalibrated}</b>} project_id={projectID} bu={bu.CalibratorBusinessUnitID} prev_calibrator={bu.CalibratorID} rating={"B+"} all={true} />,
                            bTotalScore: <ButtonRating value={<b>{bu.BCalibrated}</b>} project_id={projectID} bu={bu.CalibratorBusinessUnitID} prev_calibrator={bu.CalibratorID} rating={"B"} all={true} />,
                            cTotalScore: <ButtonRating value={<b>{bu.CCalibrated}</b>} project_id={projectID} bu={bu.CalibratorBusinessUnitID} prev_calibrator={bu.CalibratorID} rating={"C"} all={true} />,
                            dTotalScore: <ButtonRating value={<b>{bu.DCalibrated}</b>} project_id={projectID} bu={bu.CalibratorBusinessUnitID} prev_calibrator={bu.CalibratorID} rating={"D"} all={true} />,
                            total: <b>{bu.APlusCalibrated + bu.ACalibrated + bu.BPlusCalibrated + bu.BCalibrated + bu.CCalibrated + bu.DCalibrated}</b>,
                            status: bu.Status,
                            average: bu.AverageScore.toFixed(2),
                            projectID: projectID,
                            type: 'all',
                        })
                        key++
                    }

                    // Then add all the individual calibrator rows
                    data.push(...buRows)

                    // Finally add Rating Guidance row if it should be shown
                    if (filterRating) {
                        data.push({
                            key: key,
                            position: "totalbu-1",
                            businessPerformance: bu.CalibratorBusinessUnitName,
                            businessPerformanceID: bu.CalibratorBusinessUnitID,
                            previousCalibrator: <b>Rating</b>,
                            previousCalibratorID: bu.CalibratorID,
                            projectPhaseOrder: bu.CalibratorBusinessUnit?.[0]?.ProjectPhaseOrder,
                            indicator: <b>Guidance</b>,
                            aPlusTotalScore: <b>{bu.APlusGuidance}</b>,
                            aTotalScore: <b>{bu.AGuidance}</b>,
                            bPlusTotalScore: <b>{bu.BPlusGuidance}</b>,
                            bTotalScore: <b>{bu.BGuidance}</b>,
                            cTotalScore: <b>{bu.CGuidance}</b>,
                            dTotalScore: <b>{bu.DGuidance}</b>,
                            total: <b>{bu.APlusGuidance + bu.AGuidance + bu.BPlusGuidance + bu.BGuidance + bu.CGuidance + bu.DGuidance}</b>,
                        })
                        key++
                    }
                });

                if (resultData.Summary.length > 1) {
                    data.push({
                        key: key,
                        position: "last-1",
                        businessPerformance: <b>Grand Total</b>,
                        indicator: <b>Guidance</b>,
                        aPlusTotalScore: resultData.APlusGuidance,
                        aTotalScore: resultData.AGuidance,
                        bPlusTotalScore: resultData.BPlusGuidance,
                        bTotalScore: resultData.BGuidance,
                        cTotalScore: resultData.CGuidance,
                        dTotalScore: resultData.DGuidance,
                        total: resultData.APlusGuidance +
                            resultData.AGuidance +
                            resultData.BPlusGuidance +
                            resultData.BGuidance +
                            resultData.CGuidance +
                            resultData.DGuidance,
                        // average: resultData.AverageTotalScore.toFixed(2),
                        status: "summary"
                    })
                    key++
                    data.push({
                        key: key,
                        position: "last",
                        businessPerformance: <b>Grand Total</b>,
                        indicator: <b>Calibrated</b>,
                        aPlusTotalScore: <ButtonRating value={<b>{resultData.APlusTotalScore}</b>} project_id={projectID} rating={"A+"} all={true} />,
                        aTotalScore: <ButtonRating value={<b>{resultData.ATotalScore}</b>} project_id={projectID} rating={"A"} all={true} />,
                        bPlusTotalScore: <ButtonRating value={<b>{resultData.BPlusTotalScore}</b>} project_id={projectID} rating={"B+"} all={true} />,
                        bTotalScore: <ButtonRating value={<b>{resultData.BTotalScore}</b>} project_id={projectID} rating={"B"} all={true} />,
                        cTotalScore: <ButtonRating value={<b>{resultData.CTotalScore}</b>} project_id={projectID} rating={"C"} all={true} />,
                        dTotalScore: <ButtonRating value={<b>{resultData.DTotalScore}</b>} project_id={projectID} rating={"D"} all={true} />,
                        total: <b>{
                            resultData.APlusTotalScore +
                            resultData.ATotalScore +
                            resultData.BPlusTotalScore +
                            resultData.BTotalScore +
                            resultData.CTotalScore +
                            resultData.DTotalScore}</b>,
                        average: resultData.AverageTotalScore.toFixed(2),
                        projectID: projectID,
                        type: "all",
                        status: "summary"
                    })
                }

                let prevBusinessPerformance = null;
                let rowSpan = 0;

                const modifiedDataSource = data.map((record) => {
                    const currentBusinessPerformance = record.businessPerformance;
                    if (prevBusinessPerformance !== currentBusinessPerformance) {
                        prevBusinessPerformance = currentBusinessPerformance;
                        rowSpan = 1;
                    } else {
                        rowSpan++;
                    }

                    return {
                        ...record,
                        rowSpan: rowSpan > 1 ? 0 : rowSpan, // Set rowSpan to 0 for cells to be merged
                    };
                });

                modifiedDataSource.forEach((record, index) => {
                    if (record.rowSpan === 1) {
                        let consecutiveCount = 1;
                        let nextIndex = index + 1;

                        while (
                            nextIndex < modifiedDataSource.length &&
                            modifiedDataSource[nextIndex].businessPerformance === record.businessPerformance
                        ) {
                            consecutiveCount++;
                            nextIndex++;
                        }

                        if (consecutiveCount > 1) {
                            modifiedDataSource[index].rowSpan = consecutiveCount;
                            for (let i = 1; i < consecutiveCount; i++) {
                                modifiedDataSource[index + i].rowSpan = 0;
                            }
                        }
                    }
                });
                // Sort and update options only when building from unfiltered data
                if (shouldBuildOptions) {
                    listFilterRow.sort((a, b) => a.label.localeCompare(b.label))
                    listCalibratorFilter.sort((a, b) => a.label.localeCompare(b.label))
                    setOptionFilterRow(listFilterRow)
                    setCalibratorFilter(listCalibratorFilter)
                }

                setSummary([...modifiedDataSource])
            }
            setLoadingPage(false)
        } catch (error) {
            // console.log(error)
            setLoadingPage(false)
            if (error.response) {
                setSummary([])
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getProject = async (id) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/projects/${id}`)
            if (res.status === 200) {
                setProject(res.data.data)
                // console.log(res.data.data)
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                setProject([])
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    return {
        summary,
        columns,
        getSummary,
        project,
        getProject,
        loadingPagestate,
        userSummary,
        setUser,
        optionFilterRow,
        filteredRow,
        setFilteredRow,
        calibratorFilter
    }
}

export default useSummaryCurrentProject